import {
  APP_BROADCAST_ADD_REQUEST,
  APP_BROADCAST_ADD_REQUEST_SUCCESS,
  APP_BROADCAST_ADD_REQUEST_FAILURE,
  APP_BROADCAST_UPDATE_REQUEST,
  APP_BROADCAST_UPDATE_REQUEST_SUCCESS,
  APP_BROADCAST_UPDATE_REQUEST_FAILURE,
  APP_BROADCAST_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appBroadcastsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_BROADCAST_ADD_REQUEST:
    case APP_BROADCAST_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_BROADCAST_ADD_REQUEST_SUCCESS:
    case APP_BROADCAST_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case APP_BROADCAST_ADD_REQUEST_FAILURE:
    case APP_BROADCAST_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case APP_BROADCAST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default appBroadcastsReducer;
